import request from '@/utils/request'

// 用户列表信息
export function getuserlist (query) {
  return request({
    url: '/uaa/admin/user/list',
    method: 'get',
    params: query
  })
}

// 用户信息
export function getuserinfo (query) {
  return request({
    url: '/uaa/admin/' + query.username,
    method: 'get'
  })
}

// 用户反馈列表
export function getuseradvicelist (query) {
  return request({
    url: '/uaa/admin/advice/list',
    method: 'get',
    params: query
  })
}

// 测听数据列表
export function getuserhearlist (query) {
  return request({
    url: '/uaa/admin/test/list/download',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/services/userinfo.js